import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
function Price(_a) {
  var _b = _a.short,
    short = _b === void 0 ? false : _b;
  var state = useCountryValue()[0];
  var phoneInfo = state.callData.countries[state.country];
  var info = phoneInfo.info,
    mobileInfoText = phoneInfo.mobileInfoText,
    fontclass = phoneInfo.fontclass;
  var theInfo = info;
  if (state.country === "de" && state.device === "mobile") {
    theInfo = mobileInfoText;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: fontclass + " price c-host-grid__card__price"
  }, theInfo);
}
export default Price;